import { OptimisticUpdateContext } from './useRealtimeQuery';

export type MutationContext = OptimisticUpdateContext & {
    error?: Error;
    vars?: unknown;
};

export const handleMutationContext = async (
    vars: unknown,
    onMutate?: (vars: unknown) => unknown | Promise<unknown>,
    rollback?: () => void
): Promise<MutationContext> => {
    try {
        const mutateCtx = typeof onMutate === 'function' ? onMutate(vars) : vars;

        if (!rollback) {
            return mutateCtx as MutationContext;
        }

        if (mutateCtx instanceof Promise) {
            const result = await mutateCtx;
            return {
                vars: result,
                rollback,
            };
        }

        return {
            vars: mutateCtx,
            rollback,
        };
    } catch (error) {
        return {
            rollback: rollback ?? (() => {}),
            error: error instanceof Error ? error : new Error(String(error)),
        };
    }
};
